import { addMinutes, isBefore, isToday, isYesterday, startOfYesterday } from 'date-fns';
import { store } from 'store';

const dateFilters = {
  isToday,
  isYesterday,
  isBeforeYesterday: (val) => isBefore(val, startOfYesterday())
};

function filterNotifs(dateFilterName) {
  const notifs = store.getState().notifications;
  const connects = store.getState().connects || [];
  const dateFilter = dateFilters[dateFilterName];
  const now = new Date();

  const filtered = notifs?.filter((notif) => {
    if (!dateFilter(new Date(notif.updatedAt)) || !notif) return false;

    const { type } = notif;

    switch (type) {
      case 'connectRequest':
        const pendingConnects = connects.filter((x) => {
          const date = new Date(x.date);
          const createdAt = new Date(x.createdAt);

          return x.status === 'pending' && dateFilter(createdAt) && date > now;
        });

        return !!pendingConnects?.length;

      case 'connectStart':
      case 'connectInFive':
        const endTime = addMinutes(new Date(notif.connect.date), 15);
        const connect = connects.find((x) => x._id === notif.connect?._id);
        return endTime > now && !['completed', 'rejected', 'canceled'].includes(connect?.status);

      // System notifications (no sender) — moderation takedowns and warnings.
      case 'contentRemoved':
      case 'moderationWarning':
        return true;

      default:
        return !!notif.sender;
    }
  });

  return filtered?.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
}

export default filterNotifs;
